//Users
export const Save_User = (data) => ({
  type: "Save_User",
  payload: data,
});
export const Save_Property = (data) => ({
  type: "Save_Property",
  payload: data,
});

export const Select_Property = (data) => ({
  type: "Select_Property",
  payload: data,
});

export const Select_Partner = (data) => ({
  type: "Select_Partner",
  payload: data,
});

export const Select_Staff_Client = (data) => ({
  type: "Select_Staff_Client",
  payload: data,
});

export const Save_VendorTypes = (data) => ({
  type: "Save_VendorTypes",
  payload: data,
});

export const Save_Vendors = (data) => ({
  type: "Save_Vendors",
  payload: data,
});

export const Save_Partners = (data) => ({
  type: "Save_Partners",
  payload: data,
});

export const Save_Staff_Clients = (data) => ({
  type: "Save_Staff_Clients",
  payload: data,
});
export const Save_PendingTasks = (pendingTasks) => ({
  type: "Save_Pending_Tasks",
  payload: pendingTasks,
});
export const Save_BankAccounts = (bankAccounts) => ({
  type: "Save_Bank_Accounts",
  payload: bankAccounts,
});
export const Save_Locations = (data) => ({
  type: "Save_Locations",
  payload: data,
});
export const Select_Location = (data) => ({
  type: "Select_Location",
  payload: data,
});
export const Save_isStampRequired = (data) => ({
  type: "Save_isStampRequired",
  payload: data,
});
export const Save_isPayoutEnabled = (data) => ({
  type: "Save_isPayoutEnabled",
  payload: data,
});
export const Save_StaffList = (data) => ({
  type: "Save_StaffList",
  payload: data,
});
// export const Update_Property = (data) => ({
//   type: "Update_Property",
//   payload: data,
// });

export const Update_User = (data) => ({
  type: "Update_User",
  payload: data,
});

export const Remove_User = () => ({
  type: "Remove_User",
});

//Games
export const Save_Games_Data = (data) => ({
  type: "Save_Games_Data",
  payload: data,
});
